import { render, staticRenderFns } from "./SubmitInvitationButton.vue?vue&type=template&id=dd58953c&"
import script from "./SubmitInvitationButton.vue?vue&type=script&lang=js&"
export * from "./SubmitInvitationButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports